/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_1692f719{display:inline-block;vertical-align:middle;speak:none;width:1em;height:1em}.svg_1692f719{height:100%;fill:currentColor;vertical-align:top}"}]);
export const root = "root_1692f719";
export const svg = "svg_1692f719";